"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BackInStockNotificationController = void 0;
var _auth = require("@ori/auth");
var _configurationManager = require("@ori/configuration-manager");
var _environment = require("@ori/environment");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _i18n = require("@ori/i18n");
var _logger = require("@ori/logger");
var _presentationHooks = require("@ori/presentation-hooks");
var _staticApiClientReact = require("@ori/static-api-client-react");
var _testidGenerator = require("@ori/testid-generator");
var _react = require("react");
var _components = require("../../components");
var _constants = require("../../constants");
var _constantsGenerated = require("../../constants-generated");
var _contexts = require("../../contexts");
var _logger2 = require("../../logger");
var _jsxRuntime = require("react/jsx-runtime");
/* istanbul ignore file @preserve */

const localLogger = _logger2.mainLogger.createChild('BackInStockNotificationController');
// istanbul ignore next @preserve -- No need to test logging.
const onError = error => localLogger.error(new Error('TranslationsProvider fetching failed', {
  cause: error
}));
const BackInStockNotificationController = ({
  translations
}) => {
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const {
    language
  } = (0, _i18n.useTranslationsWithNamespaces)();
  const {
    globalApiUrl,
    staticApiUrl
  } = (0, _configurationManager.useServiceUrls)(['globalApi', 'staticApi']);
  const {
    token
  } = (0, _auth.useToken)();
  const {
    initialOpenDone,
    open,
    onClose,
    onOpen
  } = (0, _presentationHooks.useInitialDisclose)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_testidGenerator.TestIdProvider, {
    team: _testidGenerator.Team.Presentation,
    project: _constantsGenerated.APP_NAME,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Suspense, {
      fallback: null,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_logger.LoggerProvider, {
        logger: _logger2.mainLogger,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_logger.ErrorBoundary, {
          areaName: "BackInStockNotificationController",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_i18n.TranslationsProvider, {
            clientFetchConfiguration: initialOpenDone ? {
              baseUrl: staticApiUrl,
              onError,
              tenant
            } : undefined,
            language: language,
            defaultTranslationsWithNamespaces: {
              [_constants.translationsNamespace]: _constants.defaultTranslations
            },
            translationsWithNamespaces: translations ? {
              [_constants.translationsNamespace]: translations
            } : undefined,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_i18n.TranslationsNamespaceProvider, {
              namespace: _constants.translationsNamespace,
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_staticApiClientReact.ApiClientProvider, {
                baseUrl: staticApiUrl,
                language: language,
                tenant: tenant,
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_globalApiClientReact.ApiClientProvider, {
                  baseUrl: globalApiUrl,
                  language: language,
                  tenant: tenant,
                  token: token,
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_contexts.AppContextProvider, {
                    open: open,
                    initialOpenDone: initialOpenDone,
                    onClose: onClose,
                    onOpen: onOpen,
                    children: initialOpenDone ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.NotifyPopup, {}) : null
                  })
                })
              })
            })
          })
        })
      })
    })
  });
};
exports.BackInStockNotificationController = BackInStockNotificationController;
